import { Constants } from "./constants";

export class storeRecents {

    public storeIds : Array<String> = new Array<String>();
    public type = 'storeRecents';
    public _id = Constants.USER+'.storeRecents';
    public owner: String = Constants.USER;

}


// WEBPACK FOOTER //
// ./src/app/shared/models/storeRecents.ts